import { FormControl } from "@mui/material";

import {
  DateRangePickerProps,
  LocalizationProvider,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs, { Dayjs } from "dayjs";
import React from "react";

interface GKDatePickerProps {
  inputLabel?: string;
  id?: string;
  name?: string;
  requiredField?: boolean;
  error?: boolean;
  helperText?: string;
}

const GKDateRangePicker: React.FC<
  GKDatePickerProps & DateRangePickerProps<Dayjs>
> = (props) => {
  const { inputLabel, requiredField, helperText, error, minDate, ...rest } =
    props;

  return (
    <FormControl variant="standard" fullWidth sx={{ mt: inputLabel ? 0.7 : 0 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateRangePicker
          {...rest}
          label={inputLabel}
          name={inputLabel}
          disableFuture
          minDate={minDate || dayjs("01-01-1980")}
          slots={{ ...props?.slots, field: SingleInputDateRangeField }}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props?.slotProps?.textField,
              required: requiredField,
              sx: {
                "& .MuiFormLabel-asterisk": { color: "red" },
                "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
                  borderRadius: "8px",
                },
                "& .MuiFormHelperText-root": {
                  marginLeft: 0,
                  marginRight: 0,
                },
              },
            },
          }}
          format="DD-MM-YYYY"
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default GKDateRangePicker;
